(function () {
  function safeParseJSON(text) {
    try {
      return JSON.parse(text);
    } catch (e) {
      return null;
    }
  }

  function replaceToken(template, token, value) {
    return String(template || '').replace(token, value == null ? '' : String(value));
  }

  function formatRestockDate(isoDate, i18n) {
    if (!isoDate) return null;
    var parts = isoDate.split('-');
    if (parts.length < 3) return null;
    var day = parseInt(parts[2], 10);
    var monthIndex = parseInt(parts[1], 10) - 1;
    var raw = i18n.month_names || '';
    if (raw.indexOf('Translation missing') > -1) return null;
    var monthNames = raw.split(',');
    if (monthNames.length < 12) return null;
    var month = (monthNames[monthIndex] || '').trim();
    if (!month) return null;
    return day + ' ' + month;
  }

  // Eerstvolgende werkdag ná de voorraaddatum: de dag van binnenkomst wordt
  // verzonden, de volgende werkdag is de verwachte leverdag.
  function nextWorkdayISO(isoDate) {
    if (!isoDate) return null;
    var parts = isoDate.split('-');
    if (parts.length < 3) return null;
    var d = new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
    d.setDate(d.getDate() + 1);
    while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
    var mm = String(d.getMonth() + 1); if (mm.length < 2) mm = '0' + mm;
    var dd = String(d.getDate()); if (dd.length < 2) dd = '0' + dd;
    return d.getFullYear() + '-' + mm + '-' + dd;
  }

  function parseVariantId(value) {
    var id = parseInt(value, 10);
    return Number.isFinite(id) && id > 0 ? id : null;
  }

  function getVariantById(data, id) {
    if (!data || !data.variants || !id) return null;
    for (var i = 0; i < data.variants.length; i++) {
      if (Number(data.variants[i].id) === Number(id)) {
        return data.variants[i];
      }
    }
    return null;
  }

  function getClosestProductScope(root) {
    // Start bij de parent: de stock-status div heeft zelf [data-product-id],
    // waardoor closest() anders zichzelf matcht en de zoek-scope te smal wordt
    // (koopknop en bezorgregel staan búiten deze div).
    var start = root.parentElement || root;
    return (
      start.closest('[data-product-id]') ||
      start.closest('product-info') ||
      start.closest('.product') ||
      start.closest('.shopify-section') ||
      document
    );
  }

  function findVariantIdInElement(el) {
    if (!el) return null;

    var attrs = [
      'data-current-variant-id',
      'data-selected-variant-id',
      'data-variant-id',
      'data-upsell-variant-id'
    ];

    for (var i = 0; i < attrs.length; i++) {
      var attrValue = el.getAttribute && el.getAttribute(attrs[i]);
      var parsed = parseVariantId(attrValue);
      if (parsed) return parsed;
    }

    if (el.value) {
      var valueParsed = parseVariantId(el.value);
      if (valueParsed) return valueParsed;
    }

    return null;
  }

  function getVariantIdFromCheckedUpgradeInput(scope, data) {
    if (!scope) return null;

    var selectors = [
      '[data-revahs-upgrade] input:checked',
      '[data-revahs-upgrade-card].is-active input',
      '[data-revahs-upgrade-card].is-selected input',
      '[data-revahs-upgrade-card][aria-pressed="true"]',
      '[data-revahs-upgrade-card].is-active',
      '[data-revahs-upgrade-card].is-selected',
      'input[data-upsell-variant-id]:checked',
      'input[data-variant-id]:checked',
      'input[name="id"]:checked'
    ];

    for (var i = 0; i < selectors.length; i++) {
      var el = scope.querySelector(selectors[i]);
      var id = findVariantIdInElement(el);
      if (id && getVariantById(data, id)) return id;
    }

    return null;
  }

  function getVariantIdFromNearestForm(scope, data) {
    if (!scope) return null;

    var formInputs = scope.querySelectorAll('form[action*="/cart/add"] [name="id"]');
    for (var i = 0; i < formInputs.length; i++) {
      var id = parseVariantId(formInputs[i].value);
      if (id && getVariantById(data, id)) return id;
    }

    return null;
  }

  function getVariantIdFromHiddenInputs(scope, data) {
    if (!scope) return null;

    var inputs = scope.querySelectorAll('input[name="id"], input[data-variant-id], input[data-upsell-variant-id]');
    for (var i = 0; i < inputs.length; i++) {
      var id = findVariantIdInElement(inputs[i]);
      if (id && getVariantById(data, id)) return id;
    }

    return null;
  }

  function getVariantIdFromRoot(root, data) {
    var rootAttr = parseVariantId(root.getAttribute('data-selected-variant-id'));
    if (rootAttr && getVariantById(data, rootAttr)) return rootAttr;
    return null;
  }

  function resolveCurrentVariantId(root, data) {
    var scope = getClosestProductScope(root);

    var id =
      getVariantIdFromCheckedUpgradeInput(scope, data) ||
      getVariantIdFromNearestForm(scope, data) ||
      getVariantIdFromHiddenInputs(scope, data) ||
      getVariantIdFromRoot(root, data) ||
      parseVariantId(data.selectedVariantId);

    return id;
  }

  function getCurrentVariant(root, data) {
    var selectedId = resolveCurrentVariantId(root, data);
    var variant = getVariantById(data, selectedId);

    if (selectedId) {
      root.setAttribute('data-selected-variant-id', selectedId);
    }

    return variant || data.variants[0] || null;
  }

  function getState(variant) {
    if (!variant) return 'hidden';

    var qty = Number(variant.inventory_quantity || 0);
    var threshold = Number(variant.low_stock_threshold || 5);
    var preorderEnabled = !!variant.preorder_enabled;

    // Pre-order alleen als het expliciet aanstaat (metafield). Een variant
    // die gewoon niet bestelbaar is, is uitverkocht — daar hoort geen
    // kortingsbelofte of reserveerknop bij.
    if (preorderEnabled) return 'preorder';
    if (!variant.available) return 'sold_out';
    if (qty === 1) return 'last_piece';
    if (qty > 1 && qty <= threshold) return 'low_stock';

    return 'hidden';
  }

  function copyToClipboard(text, button, i18n) {
    if (!navigator.clipboard) {
      var textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
      
      showCopiedFeedback(button, i18n);
      return;
    }

    navigator.clipboard.writeText(text).then(function() {
      showCopiedFeedback(button, i18n);
    }).catch(function(err) {
      console.error('Copy failed:', err);
    });
  }

  function showCopiedFeedback(button, i18n) {
    var originalText = button.textContent;
    button.textContent = i18n.discount_code_copied || '✓ Gekopieerd!';
    button.classList.add('is-copied');
    
    setTimeout(function() {
      button.textContent = originalText;
      button.classList.remove('is-copied');
    }, 2000);
  }

  function renderInline(inlineEl, variant, i18n, isAccessory) {
    var state = getState(variant);

    if (state === 'hidden') {
      // Healthy stock: show green "in stock" line instead of nothing
      if (variant && variant.available && i18n.inline_in_stock) {
        inlineEl.innerHTML =
          '<span class="revahs-stock-status__dot" aria-hidden="true"></span>' +
          '<span class="revahs-stock-status__inline-text">' + i18n.inline_in_stock + '</span>';
        inlineEl.hidden = false;
        inlineEl.setAttribute('data-state', 'in_stock');
        return;
      }
      inlineEl.hidden = true;
      inlineEl.innerHTML = '';
      inlineEl.setAttribute('data-state', 'hidden');
      return;
    }

    var text = '';
    var qty = Number(variant.inventory_quantity || 0);

    if (state === 'sold_out') {
      text = i18n.inline_sold_out || 'Tijdelijk uitverkocht';
    } else if (state === 'low_stock') {
      text = replaceToken(i18n.inline_low_stock_count, '__COUNT__', qty);
    } else if (state === 'last_piece') {
      text = i18n.inline_last_piece;
    } else {
      // For accessories: use simple preorder text without discount mention
      if (isAccessory) {
        text = i18n.inline_preorder;
      } else {
        text = i18n.inline_preorder_discount || i18n.inline_preorder;
      }
      
      // Inline toont de verwachte LEVERdag: voorraaddatum + 1 werkdag
      var deliveryDate = formatRestockDate(nextWorkdayISO(variant.restock_date_iso), i18n);
      if (deliveryDate) {
        text = replaceToken(i18n.inline_preorder_with_date, '__DATE__', deliveryDate);
      }
    }

    inlineEl.innerHTML =
      '<span class="revahs-stock-status__dot" aria-hidden="true"></span>' +
      '<span class="revahs-stock-status__inline-text">' + text + '</span>';

    inlineEl.hidden = false;
    inlineEl.setAttribute('data-state', state);
  }

  // "Houd mij op de hoogte": schrijft het e-mailadres in bij Klaviyo.
  // Eerst als back-in-stock-inschrijving (triggert de Back in Stock flow);
  // lukt dat niet, dan als gewone lijstinschrijving zodat het adres nooit
  // verloren gaat.
  function subscribeBackInStock(email, variantId, companyId, listId, productHandle) {
    var bisBody = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: { email: email } } },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId }
          }
        }
      }
    };

    var listBody = {
      data: {
        type: 'subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                properties: { 'Wachtend op product': productHandle || '' }
              }
            }
          },
          custom_source: 'Back in stock formulier'
        },
        relationships: { list: { data: { type: 'list', id: listId } } }
      }
    };

    function post(path, body) {
      return fetch('https://a.klaviyo.com' + path + '?company_id=' + encodeURIComponent(companyId), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify(body)
      }).then(function (response) {
        if (!response.ok) throw new Error('Klaviyo ' + response.status);
        return response;
      });
    }

    return post('/client/back-in-stock-subscriptions/', bisBody).catch(function () {
      return post('/client/subscriptions/', listBody);
    });
  }

  function bindNotifyForm(blockEl, variant, i18n) {
    var form = blockEl.querySelector('[data-revahs-notify-form]');
    if (!form) return;

    var root = blockEl.closest('[data-revahs-stock-status]');
    var companyId = root ? root.getAttribute('data-klaviyo-company') : null;
    var listId = root ? root.getAttribute('data-klaviyo-list') : null;
    if (!companyId) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var input = form.querySelector('.revahs-stock-status__notify-input');
      var button = form.querySelector('.revahs-stock-status__notify-btn');
      var msg = form.querySelector('.revahs-stock-status__notify-msg');
      var email = input ? input.value.trim() : '';

      function showMsg(text, ok) {
        if (!msg) return;
        msg.textContent = text;
        msg.className = 'revahs-stock-status__notify-msg revahs-stock-status__notify-msg--' + (ok ? 'success' : 'error');
      }

      if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 0) {
        showMsg(i18n.notify_invalid || 'Vul een geldig e-mailadres in.', false);
        return;
      }

      if (button) button.disabled = true;

      var productHandle = root ? root.getAttribute('data-product-handle') : '';

      subscribeBackInStock(email, variant.id, companyId, listId, productHandle)
        .then(function () {
          form.querySelectorAll('input, button').forEach(function (el) { el.style.display = 'none'; });
          showMsg(i18n.notify_success || 'Gelukt! We mailen je zodra het product er weer is.', true);
        })
        .catch(function (err) {
          console.error('Back in stock inschrijving mislukt:', err);
          if (button) button.disabled = false;
          showMsg(i18n.notify_error || 'Er ging iets mis. Probeer het later opnieuw.', false);
        });
    });
  }

  function renderBlock(blockEl, variant, i18n, isAccessory) {
    var state = getState(variant);

    if (state === 'hidden') {
      blockEl.hidden = true;
      blockEl.innerHTML = '';
      blockEl.setAttribute('data-state', 'hidden');
      return;
    }

    var badge = '';
    var title = '';
    var text = '';
    var dateLine = '';
    var discountBox = '';
    var notifyForm = '';
    var qty = Number(variant.inventory_quantity || 0);

    if (state === 'sold_out') {
      badge = i18n.badge_sold_out || 'Uitverkocht';
      title = i18n.title_sold_out || 'Tijdelijk uitverkocht';
      text = i18n.text_sold_out || 'Laat je e-mailadres achter en we mailen je zodra dit product weer op voorraad is.';

      var soDate = formatRestockDate(variant.restock_date_iso, i18n) || variant.restock_date_label;
      if (soDate && i18n.date_next_stock) {
        dateLine = replaceToken(i18n.date_next_stock, '__DATE__', soDate);
      }

      notifyForm =
        '<form class="revahs-stock-status__notify" data-revahs-notify-form novalidate>' +
          '<input type="email" class="revahs-stock-status__notify-input" autocomplete="email" ' +
            'placeholder="' + (i18n.notify_placeholder || 'Jouw e-mailadres') + '" required>' +
          '<button type="submit" class="revahs-stock-status__notify-btn">' +
            (i18n.notify_submit || 'Houd mij op de hoogte') +
          '</button>' +
          '<p class="revahs-stock-status__notify-msg" role="status" aria-live="polite"></p>' +
        '</form>';
    } else if (state === 'low_stock') {
      badge = i18n.badge_low_stock;
      title = i18n.title_low_stock;
      text = replaceToken(i18n.text_low_stock_count, '__COUNT__', qty);
    } else if (state === 'last_piece') {
      badge = i18n.badge_low_stock;
      title = i18n.title_last_piece;
      text = i18n.text_last_piece;
    } else {
      // Preorder state
      // For accessories: use simple badge without discount mention
      if (isAccessory) {
        badge = i18n.badge_preorder;
      } else {
        badge = i18n.badge_preorder_discount || i18n.badge_preorder;
      }
      
      title = i18n.title_preorder;
      text = i18n.text_preorder;

      // Titel dynamisch met de voorraaddatum uit het metafield ("Nieuwe voorraad
      // verwacht: 6 juli") — nooit meer een hardcoded datum in de vertaling.
      var stockDate = formatRestockDate(variant.restock_date_iso, i18n) || variant.restock_date_label;
      if (stockDate && i18n.date_next_stock) {
        title = replaceToken(i18n.date_next_stock, '__DATE__', stockDate);
      }

      // Leverdag (voorraaddatum + 1 werkdag) als aparte regel
      var blockDelivery = formatRestockDate(nextWorkdayISO(variant.restock_date_iso), i18n);
      if (blockDelivery && i18n.inline_preorder_with_date) {
        dateLine = replaceToken(i18n.inline_preorder_with_date, '__DATE__', blockDelivery);
      }

      // CRITICAL: Only show discount code for non-accessories
      if (!isAccessory && i18n.discount_code) {
        discountBox = 
          '<div class="revahs-stock-status__discount">' +
            '<div class="revahs-stock-status__discount-label">' + i18n.discount_code_label + '</div>' +
            '<div class="revahs-stock-status__discount-code-wrapper">' +
              '<code class="revahs-stock-status__discount-code">' + i18n.discount_code + '</code>' +
              '<button type="button" class="revahs-stock-status__copy-btn" data-copy-discount>' +
                i18n.discount_code_copy +
              '</button>' +
            '</div>' +
            '<div class="revahs-stock-status__discount-note">' + i18n.discount_auto_applied + '</div>' +
          '</div>';
      }
    }


    blockEl.innerHTML =
      '<div class="revahs-stock-status__badge">' + badge + '</div>' +
      '<div class="revahs-stock-status__title">' + title + '</div>' +
      '<div class="revahs-stock-status__text">' + text + '</div>' +
      (dateLine ? '<div class="revahs-stock-status__date">' + dateLine + '</div>' : '') +
      discountBox +
      notifyForm;

    blockEl.hidden = false;
    blockEl.setAttribute('data-state', state);

    var copyBtn = blockEl.querySelector('[data-copy-discount]');
    if (copyBtn && i18n.discount_code) {
      copyBtn.addEventListener('click', function() {
        copyToClipboard(i18n.discount_code, copyBtn, i18n);
      });
    }

    if (state === 'sold_out') {
      bindNotifyForm(blockEl, variant, i18n);
    }
  }

  function interceptAddToCart(root, data) {
    // Skip discount code interception for accessories
    if (data.isAccessory) return;
    if (!data.i18n.discount_code) return;
    
    var scope = getClosestProductScope(root);
    if (!scope) return;

    var forms = scope.querySelectorAll('form[action*="/cart/add"]');
    
    forms.forEach(function(form) {
      if (form.__revahsDiscountIntercepted) return;
      form.__revahsDiscountIntercepted = true;

      form.addEventListener('submit', function(e) {
        var variant = getCurrentVariant(root, data);
        var state = getState(variant);
        
        if (state !== 'preorder') return;

        e.preventDefault();

        var formData = new FormData(form);
        var variantId = formData.get('id');
        var quantity = formData.get('quantity') || 1;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: parseInt(quantity)
            }]
          })
        })
        .then(function(response) {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(function() {
          window.location.href = '/checkout?discount=' + data.i18n.discount_code;
        })
        .catch(function(err) {
          console.error('Error adding to cart:', err);
          form.removeEventListener('submit', arguments.callee);
          form.submit();
        });
      });
    });
  }

  function updateButtonText(root, data) {
    var variant = getCurrentVariant(root, data);
    if (!variant) return;

    var state = getState(variant);
    var scope = getClosestProductScope(root);
    var forms = scope.querySelectorAll('form[action*="/cart/add"]');

    forms.forEach(function(form) {
      // Alleen formulieren van dít product aanpassen: upsell-blokken voor
      // andere producten hebben hun eigen voorraadstatus en mogen de tekst
      // van het hoofdproduct niet erven.
      var idInput = form.querySelector('[name="id"]');
      var formVariantId = idInput ? parseVariantId(idInput.value) : null;
      if (!formVariantId || !getVariantById(data, formVariantId)) return;

      var button = form.querySelector('button[type="submit"], .product-form__submit, [name="add"]');
      if (!button) return;

      if (state === 'sold_out') {
        if (!button.dataset.revahsOriginalText) {
          button.dataset.revahsOriginalText = button.textContent.trim();
        }
        button.textContent = data.i18n.button_sold_out || 'Uitverkocht';
        button.disabled = true;
        button.classList.remove('revahs-preorder-button');
        button.removeAttribute('data-is-preorder');
      } else if (state === 'preorder') {
        if (!button.dataset.revahsOriginalText) {
          button.dataset.revahsOriginalText = button.textContent.trim();
        }

        // For accessories: use simple preorder text
        var label;
        if (data.isAccessory) {
          label = data.i18n.button_preorder || 'Pre-order';
        } else {
          label = data.i18n.button_preorder || 'Reserveer nu met 10% korting';
        }

        button.dataset.revahsPreorderText = label;
        button.textContent = label;
        button.classList.add('revahs-preorder-button');
        button.setAttribute('data-is-preorder', 'true');
      } else if (button.dataset.revahsOriginalText) {
        // Variant switched back to a normal state: restore the original label
        button.textContent = button.dataset.revahsOriginalText;
        button.disabled = !variant.available;
        button.classList.remove('revahs-preorder-button');
        button.removeAttribute('data-is-preorder');
      }
    });
  }

  function updateRoot(root) {
    var jsonEl = root.querySelector('[data-revahs-stock-variants]');
    var inlineEl = root.querySelector('[data-revahs-stock-inline]');
    var blockEl = root.querySelector('[data-revahs-stock-block]');

    if (!jsonEl || !inlineEl || !blockEl) return;

    var data = safeParseJSON(jsonEl.textContent);
    if (!data || !data.variants || !data.i18n) return;

    var variant = getCurrentVariant(root, data);
    if (!variant) return;

    var isAccessory = !!data.isAccessory;

    renderInline(inlineEl, variant, data.i18n, isAccessory);
    renderBlock(blockEl, variant, data.i18n, isAccessory);
    interceptAddToCart(root, data);
    updateButtonText(root, data);

    // Hide the buybox delivery bar when in preorder or sold-out state
    // Only act from the visible stock-status root (skip hidden variant wrappers)
    var rootWrapper = root.closest('.rbuybox__stock-status');
    var isVisible = !rootWrapper || rootWrapper.style.display !== 'none';
    if (isVisible) {
      var state = getState(variant);
      var hideDelivery = state === 'preorder' || state === 'sold_out';
      var scope = getClosestProductScope(root);
      var deliveryBars = scope ? scope.querySelectorAll('#rbuybox-delivery, .rbuybox__delivery, .rbox1__delivery') : [];
      deliveryBars.forEach(function (bar) {
        bar.style.display = hideDelivery ? 'none' : '';
      });

      // Accessoirepagina: de regel "Voor 21:59 besteld, morgen in huis" staat
      // in een eigen trust-rij; die belofte klopt niet bij een onbestelbaar
      // product.
      var accDelivery = scope ? scope.querySelectorAll('[id^="acc-delivery-"]') : [];
      accDelivery.forEach(function (el) {
        var row = el.closest('.revahs-acc__trust-row') || el;
        row.style.display = hideDelivery ? 'none' : '';
      });

      // Sticky koopbalk (accessoirepagina): verbergen bij uitverkocht,
      // pre-order-label tonen bij pre-order.
      document.querySelectorAll('.racc-sticky').forEach(function (bar) {
        bar.style.display = (state === 'sold_out') ? 'none' : '';
        var stickyBtn = bar.querySelector('.racc__btn-sticky');
        if (!stickyBtn) return;
        if (state === 'preorder') {
          if (!stickyBtn.dataset.revahsOriginalText) {
            stickyBtn.dataset.revahsOriginalText = stickyBtn.textContent.trim();
          }
          var stickyLabel = data.i18n.sticky_button_preorder;
          if (stickyLabel && stickyLabel.indexOf('Translation missing') === -1) {
            stickyBtn.textContent = stickyLabel;
          }
        } else if (stickyBtn.dataset.revahsOriginalText) {
          stickyBtn.textContent = stickyBtn.dataset.revahsOriginalText;
        }
      });
    }
  }

  function bindRoot(root) {
    if (!root || root.__revahsStockStatusInit) return;
    root.__revahsStockStatusInit = true;

    updateRoot(root);

    var delayedUpdate = function () {
      window.setTimeout(function () {
        updateRoot(root);
      }, 30);
    };

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target) return;

      var isRelevant =
        target.matches('form[action*="/cart/add"] [name="id"]') ||
        target.matches('input[name="id"]') ||
        target.matches('variant-selects select') ||
        target.matches('variant-radios input') ||
        target.matches('[data-upsell-variant-id]') ||
        target.matches('[data-variant-id]') ||
        target.closest('[data-revahs-upgrade]') ||
        target.closest('[data-revahs-upgrade-card]');

      if (!isRelevant) return;
      delayedUpdate();
    });

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target) return;

      var trigger = target.closest('[data-revahs-upgrade-card], [data-upsell-variant-id], [data-variant-id]');
      if (!trigger) return;

      delayedUpdate();
    });

    document.addEventListener('variant:change', delayedUpdate);
    document.addEventListener('product:variant-change', delayedUpdate);

    document.addEventListener('revahs:upgrade-change', function (event) {
      var detail = event && event.detail ? event.detail : {};
      var variantId = parseVariantId(detail.variantId || detail.variant_id || detail.id);

      if (variantId) {
        root.setAttribute('data-selected-variant-id', variantId);
      }

      delayedUpdate();
    });
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-revahs-stock-status]');
    roots.forEach(bindRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();